import {Company} from "./company.model";

export class UserModel {

  protected ROLES = {
    Admin: 1,
    Operator: 2,
    Client: 3
  };

  public name?: string;
  public username?: string;
  public email?: string;
  public role?: any;
  public role_id?: number;
  public companies?: Company[];

  constructor (data?: any) {
    if (data) {
      this.name = data.name;
      this.username = data.id;
      this.email = data.email;
      this.role = data.role;
      this.role_id = data.role && data.role.id ? data.role.id : null;
      if (data.companies) {
        this.companies = data.companies.map(c => new Company(c))
      }
    }
  }

  isAdmin() {
    return this.role && +this.role.id === this.ROLES.Admin
  }

  isOperator() {
    return this.role && +this.role.id === this.ROLES.Operator
  }

  isClient() {
    return this.role && +this.role.id === this.ROLES.Client
  }
}
